import { render, staticRenderFns } from "./AboutPageTeamBlock.vue?vue&type=template&id=8fe10cf2&"
import script from "./AboutPageTeamBlock.vue?vue&type=script&lang=js&"
export * from "./AboutPageTeamBlock.vue?vue&type=script&lang=js&"
import style0 from "./AboutPageTeamBlock.vue?vue&type=style&index=0&id=8fe10cf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports